export function fiRegexQuote(str: string) {
    return str.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
}
